import React from "react";
import { useAuth } from "@/App";

export default function PageHeader({ title, subtitle, children }) {
  const { user } = useAuth();
  return (
    <div className="h-14 flex items-center justify-between px-6 border-b border-zinc-800/60 bg-[#0f0f12]/80 backdrop-blur-md sticky top-0 z-10">
      <div>
        <h1 className="font-heading text-base font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="text-[11px] text-zinc-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">
        {children}
      </div>
    </div>
  );
}
